import React from 'react';

import './contact-form.scss';
import cs from "classnames";



const ContactForm = ({ formId }) => {
  const [ success, setSuccess ] = React.useState(false);
  const [ error, setError ] = React.useState(false);
  const [ company, setCompany ] = React.useState();
  const [ project, setProject ] = React.useState();
  const [ email, setEmail ] = React.useState();
  const [ phone, setPhone ] = React.useState();
  const [ name, setName ] = React.useState();
  const width = window.innerWidth;



  const onSubmit = event => {
    event.preventDefault();

    const url = '/svalka/api/expressform/';
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ company, project, email, phone, name })
    };

    fetch(url, requestOptions)
        .then(() => {
          setError(false);
          setSuccess(true);
        })
        .catch(() => {
          setError(true);
          setSuccess(false);
        })
  }

  return (
      <React.Fragment>
        <section className="contactus" id="contact">
          <div
              id="l-express-form-container"
              className={cs(
                  "contactus_form",
                  {
                    "success": success,
                    "error": error
                  }
              )}
          >
            <h2 className="header">Заказ дизайна</h2>
            <p>Достаточно рассказать о&nbsp;своем проекте&nbsp;&mdash; мы&nbsp;свяжемся, чтобы все обсудить</p>
            <form onSubmit={onSubmit}>
              <input
                  required
                  name="company"
                  placeholder="Название компании"
                  onChange={e => setCompany(e.target.value)}
              />
              <input
                  required
                  name="project"
                  placeholder={width > 600 ? "Несколько слов о проекте и  приблизительный бюджет" : "Несколько слов о проекте"}
                  onChange={e => setProject(e.target.value)}
              />
              <input
                  required
                  name="email"
                  placeholder="Электропочта"
                  onChange={e => setEmail(e.target.value)}
              />
              <input
                  required
                  name="phone"
                  placeholder={width > 600 ? "Телефон или любой удобный мессенджер" : "Телефон или мессенджер"}
                  onChange={e => setPhone(e.target.value)}
              />
              <input
                  required
                  name="name"
                  placeholder="Имя"
                  onChange={e => setName(e.target.value)}
              />
              <button type="submit">Отправить заявку</button>
              <input type="hidden" name="form_id" value={formId} />
            </form>
            <div className="contactus_success">
              <h2>Спасибо, заявка отправлена!</h2>
            </div>
            <div className="contactus_error">
              <h2>Что-то пошло не так, попробуйте еще раз!</h2>
            </div>
          </div>
        </section>
      </React.Fragment>
  );
}

export default ContactForm;
